<template>
  <div class="scene-final-desktop" :class="classList">
    <MapObject class="scene-final-desktop__trees" src="/map/desktop_final_trees.png" type="trees" :animated="ready"></MapObject>
    <MapObject class="scene-final-desktop__b1" src="/map/build_6f.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-final-desktop__b2" src="/map/build_8f_1.png" type="building" :animated="ready"></MapObject>
    <MapObject class="scene-final-desktop__b3" src="/map/build_8f_2.png" type="building" :animated="ready"></MapObject>
  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene
  }
</script>

<style lang="scss">
  .scene-final-desktop {
    @include relative-units(566px, 358px, desktop)
  }


  .scene-final-desktop__trees {
    top: 0;
    left: 0;
    width: 100%;
  }
  .scene-final-desktop__b1 {
    left: 62.5%;
    top: 45.3%;
    width: 14.6%;
  }
  .scene-final-desktop__b2 {
    left: 47.7%;
    top: 54.9%;
    width: 14.2%;
  }
  .scene-final-desktop__b3 {
    left: 36.5%;
    top: 65.6%;
    width: 14.4%;
  }
</style>
